'use client';
import React, { Suspense } from 'react';
import { SectionTitle } from '@benzinga/core-ui';
import type { BaseQuotePageProps } from '../../../../../src/utils/quote/types';
import QuotePageTitleLink from '../_components/QuotePageTitleLink';
import PeerComparisonSection from '../../../../../src/components/Quote/PeerComparisonSection';
import { QuoteFooter } from '../../../../../src/components/Quote/QuoteFooter';
import PeopleAlsoWatch from '../_components/PeopleAlsoWatch';

const FreestarAd = React.lazy(() =>
  import('@benzinga/ads').then(module => ({ default: module.FreestarAd })),
);

type ComparePeersContentProps = BaseQuotePageProps;

const ComparePeersContent: React.FC<ComparePeersContentProps> = ({
  metaProps,
  profile,
  symbol,
}) => {
  return (
    <>
      <div className="main-div">
        <div className="flex flex-col gap-4 lg:flex-row">

          <div className="flex flex-col gap-y-8 w-full lg:w-9/12">

            <div className="flex flex-col gap-2">
              <SectionTitle level={1} uppercase={false}>
                <QuotePageTitleLink title={metaProps.title} symbol={symbol} />
              </SectionTitle>
              <p className="section-description">{metaProps.description}</p>
            </div>

            <PeerComparisonSection symbol={symbol} peerSymbols={profile.peerSymbols} />

            <QuoteFooter activeTab="compare-peers" />
          </div>

          <PeopleAlsoWatch profile={profile} symbol={symbol}>
            <Suspense fallback={<div />}>
              <FreestarAd className="w-[300px] min-w-[300px]" onlyDesktop={true} placement="sidebar_2" />
            </Suspense>
          </PeopleAlsoWatch>
        </div>
      </div>
    </>
  );
};

export default ComparePeersContent;
